import BlogHelpers from "./BlogHelpers"

const _additionalPostsSources = context => {
  return context.additionalPostsSources || []
}

const fetchPosts = async (
  context,
  token,
  filters,
  categories,
  tags,
  wordpressUrl,
  pageNumber,
  pageArticles = 15
) => {
  let additionalPostsSources = _additionalPostsSources(context)
  additionalPostsSources.push(wordpressUrl)

  let posts = []
  additionalPostsSources.forEach(async src => {
    let sourcePosts = await BlogHelpers.fetchPosts(
      token,
      filters,
      categories,
      tags,
      src,
      pageNumber,
      pageArticles
    )
    posts = posts.concat(sourcePosts)
  })

  console.log(`fetchPosts`)

  return posts
}

const fetchPostsAdvanced = async (
  context,
  token,
  filters,
  categories,
  tags,
  wordpressUrl,
  pageNumber,
  pageArticles
) => {
  // const x = await BlogHelpers.fetchPostsAdvanced(
  //   token,
  //   filters,
  //   categories,
  //   tags,
  //   wordpressUrl,
  //   pageNumber
  // )
  // console.log(x)
  // return x

  let additionalPostsSources = _additionalPostsSources(context)
  additionalPostsSources.push(wordpressUrl)
  additionalPostsSources = [... new Set(additionalPostsSources)]

  let posts = []
  let sourcePosts = []
  let postsCount = parseInt(0)
  let sourcesStates = []
  for (const src of additionalPostsSources) {
    sourcePosts = await BlogHelpers.fetchPostsAdvanced(
      token,
      filters,
      categories,
      tags,
      src,
      pageNumber
    )
    postsCount += parseInt(sourcePosts.numberOfPosts)
    console.log(src, sourcePosts)
    /**
     * temporary hack for correct tagging of code posts (to be removed)
     */
    if (src !== wordpressUrl) sourcePosts.data.forEach(p => {
      if (p.categories && p.categories.nodes) {
        p.categories.nodes.push({name: `technical`})
      }
      p.uri = `${context.codeWebsiteUrl}/blog${p.uri}`
    })
    /**
     * / temporary hack for correct tagging of code posts
     */
    posts = posts.concat(sourcePosts.data.map(p => ({ ...p, src: src })))
    console.log(posts)
    sourcesStates.push({
      src: src,
      lastPostIndx: 0,
    })
  }

  console.log(postsCount, pageArticles)

  const consolidatedPosts = {
    data: posts.sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, pageArticles),
    currentPage: sourcePosts.currentPage || 0,
    numberOfPages: Math.ceil(postsCount / pageArticles),
    sourcesStates: sourcesStates,
  }
  console.log(consolidatedPosts)

  return consolidatedPosts
}

const AdvancedBlogHelpers = {
  fetchPosts: fetchPosts,
  fetchPostsAdvanced: fetchPostsAdvanced,
}

export default AdvancedBlogHelpers
